"use client";
import { ark } from "../factory.js";
import { useProgressContext } from "./use-progress-context.js";
import { forwardRef } from "react";
import { mergeProps } from "@zag-js/react";
import { jsx } from "react/jsx-runtime";
//#region src/components/progress/progress-track.tsx
var ProgressTrack = forwardRef((props, ref) => {
	const mergedProps = mergeProps(useProgressContext().getTrackProps(), props);
	return /* @__PURE__ */ jsx(ark.div, {
		...mergedProps,
		ref
	});
});
ProgressTrack.displayName = "ProgressTrack";
//#endregion
export { ProgressTrack };
